import './Pay.css';
import React from 'react';
import gif from './under-construction.gif';

function Pay() {
  return (
    <div className="fit py-5">
      <div className="py-4"><img src={gif} alt="" /></div>
      <h4>Payment system coming soon.</h4>
    </div>
  );
}

export default Pay;
